module.exports = __webpack_public_path__ + "img/2@2x.fe7df101.png";